import { render, staticRenderFns } from "./newTrackQuery.vue?vue&type=template&id=b66abb0c"
import script from "./newTrackQuery.vue?vue&type=script&lang=js"
export * from "./newTrackQuery.vue?vue&type=script&lang=js"
import style0 from "./newTrackQuery.vue?vue&type=style&index=0&id=b66abb0c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66abb0c')) {
      api.createRecord('b66abb0c', component.options)
    } else {
      api.reload('b66abb0c', component.options)
    }
    module.hot.accept("./newTrackQuery.vue?vue&type=template&id=b66abb0c", function () {
      api.rerender('b66abb0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/newTrackQuery.vue"
export default component.exports